'use client'

import { useEffect, useState } from 'react'

import IconButton from '@mui/material/IconButton'
import type { Theme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import classnames from 'classnames'

import { Box, CircularProgress, Link } from '@mui/material'

import FrontMenu from './FrontMenu'

import { frontLayoutClasses } from '@layouts/utils/layoutClasses'

const Header = ({ styles }: { styles: any }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const isBelowLgScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const [isHeaderVisible, setIsHeaderVisible] = useState(false) // Header dimulai dengan tersembunyi

  const [mounted, setMounted] = useState(false)

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset // Posisi scroll saat ini

    if (currentScrollPos > 10) {
      // Munculkan header ketika scroll lebih dari 10px
      setIsHeaderVisible(true)
    } else {
      // Sembunyikan header saat berada di posisi paling atas
      setIsHeaderVisible(false)
    }
  }

  useEffect(() => {
    setMounted(true)

    window.addEventListener('scroll', handleScroll)

    // Pastikan header tersembunyi saat halaman dimuat pertama kali
    setIsHeaderVisible(false)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (!mounted) return null

  return (
    <header className={`${frontLayoutClasses.header} ${isMobile ? styles.headerMobile : styles.header}`}>
      <div className={classnames(frontLayoutClasses.navbar, styles.navbar)}>
        <div className={classnames(frontLayoutClasses.navbarContent, styles.navbarContent)}>
          {isBelowLgScreen ? (
            <div className='flex items-center justify-between w-full gap-2 sm:gap-4'>
              {/* Logo di kiri */}
              {isMobile && (
                <div className={`header-container ${isHeaderVisible ? 'fade-in' : 'fade-out'}`}>
                  <Link href='/'>
                    <div className='flex items-center min-bs-[24px]'>
                      <img
                        src='/images/icon/logo.png'
                        alt='logo'
                        width={isMobile ? 60 : 100}
                        height={isMobile ? 35 : 65}
                      />
                    </div>
                  </Link>
                </div>
              )}

              {/* Menu button di kanan */}
              <div className='flex items-center gap-2 sm:gap-4 ms-auto'>
                <IconButton onClick={() => setIsDrawerOpen(true)}>
                  <i className={`ri-menu-line ${isMobile ? 'text-primary' : 'text-primary'}`} />
                </IconButton>
                <FrontMenu isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
              </div>
            </div>
          ) : (
            <div className='flex items-center gap-10'>
              {isHeaderVisible && (
                <div className={`header-container ${isHeaderVisible ? 'fade-in' : 'fade-out'}`}>
                  <Link href='/'>
                    <div className='flex items-center min-bs-[24px]'>
                      <img
                        src='/images/icon/logo.png'
                        alt='logo'
                        width={isMobile ? 60 : 100}
                        height={isMobile ? 35 : 65}
                      />
                    </div>
                  </Link>
                </div>
              )}
              <FrontMenu isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
